<template>
  <b-container class="text-center">
    <h1>Is the coffee ready?</h1>
    <div>
      {{statusString[state]}}
    </div>

    <i class="fas fa-coffee fa-10x"></i>
    
    <div>
      <b-button v-if="state=='cold'" @click="changeState('warm')" variant=secondary>Coffee is brewing!</b-button>
      <b-button v-if="state=='warm'" @click="changeState('hot')" variant=primary>Coffee is ready!</b-button>
      <b-button v-if="state=='hot'" @click="changeState('cold')" variant=danger>Coffee is gone :(</b-button>
    </div>
  </b-container>
</template>

<script>
const BASE_API = process.env.VUE_API_ROOT;
import axios from 'axios';

export default {
  data() {
    return {
      state: 'cold',
      statusString: {
        "cold": "There's no coffee brewing at the moment... maybe you should put some on!",
        "warm": "Coffee's brewing... should only be a few more minutes!",
        "hot": "Coffee's ready! Come get it while its hot!",
      },
    }
  },
  mounted() {
    this.getState();
    this.checkNotificationStatus();
    setInterval(this.getState, 1000 * 60);
  },
  methods: {
    getState() {
      axios.get(`${BASE_API}/coffee/`).then(response => {
        if (response.data.Status !== this.state) {
          new Notification(this.statusString[response.data.Status]);
        }
        this.state = response.data.Status
      }).catch(error => console.error(error))
    },
    changeState(newState) {
      this.state = newState;
      axios({
        method: 'post',
        url: `${BASE_API}/coffee/`,
        data: newState,
        headers: { 'Content-Type': 'text/plain' }})
      .catch(error => console.error(error))
    },
     checkNotificationStatus() {
      if (!("Notification" in window)) {
        alert("This browser does not support desktop notification");
      }
      else if (Notification.permission !== "denied") {
        Notification.requestPermission();
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/office-info/CoffeeNotifier.vue